var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBilling = function SvgBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F8F9FA",
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "m35.386 34.977 4.011-3.628a8.57 8.57 0 0 1 6.875-2.135l5.308.703 7.366-3.98a.714.714 0 0 1 1.054.629v13.537a2.86 2.86 0 0 1-1.194 2.323l-4.96 3.545L43.1 36.957l-3.557 2.88a3.2 3.2 0 0 1-4.157-4.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "m35.386 34.977 3.851-3.48a8.76 8.76 0 0 0-7.163-1.954l-5.245.908-5.755-3.097A.73.73 0 0 0 20 28v12.103c0 .966.477 1.868 1.274 2.411L36.86 53.14a5.84 5.84 0 0 0 6.669-.063l10.757-7.363-.032-.028-.408.288-5.372-4.503a7.14 7.14 0 0 0 2.76-1.8 1.787 1.787 0 1 0-2.571-2.482c-.529.551-1.143.905-1.863 1.048-.626.12-1.423.1-2.426-.208L43.1 36.957l-3.557 2.88a3.2 3.2 0 0 1-4.157-4.86",
    clipRule: "evenodd"
  })));
};
export default SvgBilling;